import { CgSpinner } from "react-icons/cg";
import "./style.css";

interface Props {
  hasParent?: boolean;
  loadingClassName?: string;
}
export default function Loading({ hasParent = true, loadingClassName }: Props) {
  return (
    <>
      <div
        className={
          hasParent
            ? "min-h-32 flex items-center justify-center w-full"
            : "max-h-7"
        }
      >
        <CgSpinner
          className={`animate-spin w-10 h-10 mx-auto text-azulfy-blue ${loadingClassName || ""}`}
        />
      </div>
    </>
  );
}
